import { Fragment } from "react";
import { Link } from "react-router-dom";
import "./Breadcrumb.css";

export interface BreadcrumbItem {
  label: string;
  /** Renders a router Link when set (ignored for the trailing/active crumb). */
  to?: string;
  /** Shows the home icon before the label. */
  home?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  /** Extra class on the <nav> for page-specific padding overrides. */
  className?: string;
}

const HomeIcon = () => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 14.414"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M1 5.207 6 1l5 4.207v7.207a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5.207Z"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
);

export const Breadcrumb = ({ items, className }: BreadcrumbProps) => (
  <nav
    className={`cf-breadcrumb${className ? ` ${className}` : ""}`}
    aria-label="Breadcrumb"
  >
    {items.map((item, i) => {
      const isLast = i === items.length - 1;
      const crumbClass = `cf-breadcrumb__crumb${item.home ? " cf-breadcrumb__crumb--home" : ""}${isLast ? " cf-breadcrumb__crumb--active" : ""}`;

      return (
        <Fragment key={item.label}>
          {i > 0 && (
            <span className="cf-breadcrumb__sep" aria-hidden="true">
              /
            </span>
          )}
          {item.to && !isLast ? (
            <Link to={item.to} className={crumbClass}>
              {item.home && <HomeIcon />}
              {item.label}
            </Link>
          ) : (
            <span className={crumbClass}>
              {item.home && <HomeIcon />}
              {item.label}
            </span>
          )}
        </Fragment>
      );
    })}
  </nav>
);
